import React from "react";
import Icon from "../icons/Icon";
import classes from "./TabButton.module.css";

const TabButton = ({ label, isActive, onClick, icon }) => (
    <button
        type="button"
        className={`${classes.Tab} ${isActive ? classes.TabActive : ""}`}
        onClick={onClick}
    >
        {icon && (
            <Icon
                name={icon}
                size="18px"
                color={isActive ? "#aa1b89" : "#292d32"}
            />
        )}
        <span>{label}</span>
    </button>
);

export default TabButton;
